export default {
	BINARY: 'Binary',
	BOOLEAN: 'Boolean',
	CONTINUOUS: 'Continuous',
	COUNT: 'Count',
	DOSAGE: 'Dosage',
	FUNDING: 'Funding',
	INCIDENCE: 'Incidence',
	LOCATION: 'Location',
	NUMBER: 'Number',
	PREVALENCE: 'Prevalence',
	RANGE: 'Range',
	TEXT: 'Text',
	TIME: 'Time',
	UNCOLLECTED: 'Uncollected',
}
